export default "__VITE_ASSET__CDY$lZAR__"